<!-- 首页 -->
<template>
    <div>
        <van-tabs v-model="activeName" sticky class="custom-tabs">
            <van-tab title="首页" name="home">
                <HomeContent />
            </van-tab>
            <van-tab title="福彩3D" name="fc3d" to="/fc3d">
                <!-- <LotteryPage :lotteryId="1" /> -->
            </van-tab>
            <van-tab title="排列三" name="pl3" to="/pl3">
                <!-- <LotteryPage :lotteryId="2" /> -->
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import HomeContent from '@/components/Home'
import LotteryPage from '@/components/LotteryPage'
export default {
    name: 'Home',
    components: { HomeContent, LotteryPage },
    data() {
        return {
            activeName: 'home'
        }
    }
}
</script>

<style scoped>
/* 控制视口背景色不随滚动条滚动 */
.page {
    position: relative;
    min-height: 100vh;
    z-index: 0;
}

.page::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* 你的渐变背景 */
    background: linear-gradient(to bottom, #FDE3E2 0,
            #fff 100px);
    z-index: -1;
    /* 避免闪烁 */
    will-change: transform;
    -webkit-backface-visibility: hidden;
}

.content {
    position: relative;
    z-index: 1;
    padding: 20px;
    color: #fff;
}

.custom-tabs {
    background: linear-gradient(to bottom, #FDE3E2 0,
            #fff 100px);
}

.custom-tabs::v-deep>div>div>div.van-tabs__wrap {
    /* 设置你想要的标签栏高度 */
    /* height: 30px; */
}

/* 控制顶部tab菜单的背景颜色和页面背景色一致 */
.custom-tabs::v-deep>div>div>div.van-tabs__wrap>.van-tabs__nav {
    background: linear-gradient(to bottom, #FDE3E2 0,
            #fff 100px);
}
</style>